// assets
import { IconKey ,IconAccessible} from '@tabler/icons';

// constant
const icons = {
    IconKey,
    IconAccessible
};

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //
//[1,3,5,7,8,0]

const Limit = {

    id: 'limit',
    title: 'Limit Management',
    type: 'group',
    display_id:'E',
    icon: icons.IconAccessible,

    children: [
      {
            id: 'limit_request',
            display_id:20,
            title: 'Requests',
            type: 'item',
            url: '/Admin/limit/requests',
            breadcrumbs: false
        },
        {
            id: 'limit_request_sbi',
            title: 'SBI Kiosk',
            display_id:21,
            type: 'item',
            url: '/Admin/limit/sbi_kiosk',
            breadcrumbs: false
        },
        {

            id: 'limit_topup_checker',
            display_id:84,
            title: 'Topup Checker',
            type: 'item',
            url: '/Admin/limit/topup_checker',
            breadcrumbs: false
        }
    ]

};

export default Limit;
